// extracted by mini-css-extract-plugin
module.exports = {"card":"Card_card__rHpM6","card__img":"Card_card__img__1aHW-"};